<div
  #element
  *ngIf="searchBlockContent?.formContent"
  class="pt-2 pb-1 search-container scroll-able"
  data-test-id="search-block-component"
>
  <section class="px-2 pb-1 heading-container">
    <div>
      <div class="d-inline-block align-middle px-1">
        <svg-icon src="assets/icons/icon-map.svg" class="icon-map"> </svg-icon>
      </div>
      <h3 class="d-inline-block align-middle m-0 mt-1">
        {{ searchBlockContent.title | translate }}
      </h3>
    </div>
    <button
      class="btn btn-link px-1 pt-0"
      type="button"
      data-test-id="close-search-block"
      (click)="onCloseSearchBlock($event)"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </section>
  <section class="w-100" [attr.data-test-id]="'search-block-filters'">
    <div class="accordion" id="searchFilters" [attr.data-test-id]="'searchFilters'">
      <div class="filters-card">
        <div
          class="filters-card-header px-2 py-0"
          data-test-id="filters-card-header-search"
          id="filters-search"
          [attr.data-test-id]="'filters-search'"
        >
          <h2 class="mb-0">
            <button
              class="btn btn-link fw-bold text-start w-100"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#hideFilters"
              aria-expanded="true"
              aria-controls="hideFilters"
            >
              {{ 'MAP_SEARCH_BLOCK_FILTERS_HINT' | translate }}
            </button>
          </h2>
        </div>
        <div
          id="hideFilters"
          [attr.data-test-id]="'hideFilters'"
          class="collapse show"
          aria-labelledby="filters"
          data-parent="#searchFilters"
        >
          <div class="collapse-filters px-1 h-100">
            <div class="filters-card-body px-2">
              <app-form-constructor [formContent]="searchBlockContent.formContent"></app-form-constructor>
            </div>
            <div class="text-end p-2 mb-1">
              <button
                class="btn btn-secondary me-2"
                type="submit"
                data-test-id="btn-reset-form"
                (click)="onResetForm($event)"
              >
                {{ 'RESET_BTN_HINT' | translate }}
              </button>
              <button
                class="btn btn-primary"
                type="submit"
                data-test-id="btn-submit-form-search"
                (click)="onSubmitForm($event)"
              >
                {{ 'MAP_SEARCH_BLOCK_SEARCH_BUTTON_HINT' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section [attr.data-test-id]="'search-block-map-goto'">
    <app-map-goto-block
      [mapGotoBlockContent]="goToBlockContent"
      (mapGotoSubmittedEvent)="goToSubmitted.emit($event)"
    ></app-map-goto-block>
  </section>
  <section *ngIf="!markers[0]?.isAggregated" class="p-1 w-100 filters-results" [attr.data-test-id]="'filters-results'">
    <app-map-search-results
      [flags]="flags"
      [isAdminSession]="isAdminSession"
      [markers]="markers"
      [totalMatchesCount]="mapMarkersTotal"
      [mediator]="mediator"
      [content]="searchBlockContent"
    ></app-map-search-results>
  </section>
  <section
    *ngIf="markers[0]?.isAggregated && flags?.isSearchFormSubmitted"
    [attr.data-test-id]="'aggregated-result-container'"
    class="px-1 aggregated-result-container"
  >
    <h3
      class="ps-1 m-1"
      [attr.data-test-id]="'search-result-count'"
      [innerHtml]="
        (mapMarkersTotal === 1 ? 'MAP_SEARCH_ONE_RESULT_GLOBALLY_HINT' : 'MAP_SEARCH_MULTIPLE_RESULTS_GLOBALLY_HINT')
          | translate: { count: mapMarkersTotal | number: DIGITS_REPRESENTATION_OPTIONS }
      "
    ></h3>
    <h4
      class="ps-1 m-1"
      [attr.data-test-id]="'search-zoom-in'"
      [innerHtml]="'MAP_SEARCH_ZOOM_IN_HINT' | translate"
    ></h4>
  </section>
</div>
